import css from 'styled-jsx/css';
import { pageWidth } from 'styles/css-constants';

export default css`
  @media (min-width: 48rem) {
    .Spread__items {
      flex-direction: row;
      flex-wrap: wrap;
      padding: 0 1.5rem;
    }

    .Spread__item--ad {
      flex: 0 0 100%;
      max-width: 100%;
    }

    .Spread__item--teaser {
      flex: 0 0 50%;
      max-width: 50%;
      padding: 0 0.75rem;
    }
  }

  @media (min-width: 64rem) {
    .Spread__items {
      width: ${pageWidth.large};
      margin: 0 auto;
      padding: 0;
    }
  }

  @supports (display: grid) {
    @media (min-width: 48rem) {
      .Spread__item--ad {
        grid-column: span 4;
      }

      .Spread__item--teaser {
        max-width: none;
        padding: 0;
      }

      .Spread__item--teaser:nth-child(2n + 1) {
        grid-column-start: 2;
      }

      .Spread__items {
        display: grid;
        grid-column-gap: 1.5rem;
        grid-row-gap: 1.5rem;
        grid-template-columns: 0px repeat(2, 1fr) 0px;
        padding: 0;
      }
    }

    @media (min-width: 64rem) {
      .Spread__items {
        margin: 0;
        display: grid;
        grid-row-gap: 2.25rem;
        grid-template-columns:
          1fr repeat(2, calc((${pageWidth.large} - 24px) / 2))
          1fr;
        width: 100%;
        padding: 0;
      }
    }

    @media (min-width: 75rem) {
      .Spread__items {
        grid-template-columns:
          1fr repeat(2, calc((${pageWidth.midlarge} - 24px) / 2))
          1fr;
      }
    }
  }
`;
